export default {"src":"/_next/static/media/flag-US.72e7738b.svg","height":18,"width":24,"blurWidth":0,"blurHeight":0};